import { Duration } from 'luxon';

export type TierData = {
  price: number;
  pricing_id: string;
  duration: Duration;
};

// keep in sync with premium_pass.rb Stripe::Webhooks::Beatsperminute::PremiumPass
export const tiers: TierData[] = [
  //{ price: 1, pricing_id: "price_1S7zjXA3QBiyWBd2DHXAPSK8", duration: Duration.fromObject({ days: 1 }) },
  //{ price: 5, pricing_id: "price_1S7zjtA3QBiyWBd2s9hN4aEI", duration: Duration.fromObject({ weeks: 1 }) },
  { price: 3, pricing_id: "price_1SAVMTA3QBiyWBd2NKdtJD3T", duration: Duration.fromObject({ weeks: 1 }) },
  //{ price: 10, pricing_id: "price_1S7zk3A3QBiyWBd2Chhvsyr5", duration: Duration.fromObject({ months: 1 }) },
  { price: 9, pricing_id: "price_1SAVMdA3QBiyWBd2zp3tl2C5", duration: Duration.fromObject({ months: 1 }) },
  { price: 20, pricing_id: "price_1S7zkaA3QBiyWBd2WD9qvA5Z", duration: Duration.fromObject({ years: 1 }) },
  //{ price: 30, pricing_id: "price_1S7zkoA3QBiyWBd2YH8pgtns", duration: Duration.fromObject({ years: 2 }) },
  { price: 50, pricing_id: "price_1S7zl1A3QBiyWBd2mlB7f3b9", duration: Duration.fromObject({ years: 10 }) },
  //{ price: 100, pricing_id: "price_1S7zl9A3QBiyWBd2ajHgTRMn", duration: Duration.fromObject({ days: 1 }) },
];

// test_deployed sandbox
export const tiersTestMode: TierData[] = [
  { price: 1, pricing_id: "price_1S9cxVAsb5158waWAjM18Xkg", duration: Duration.fromObject({ days: 1 }) },
  { price: 5, pricing_id: "price_1S9cxiAsb5158waWv2Wd4tFw", duration: Duration.fromObject({ days: 1 }) },
];
